/* components/SiteHeader.ts
Global Site Header

Example
<site-header>
    Site header content here
</site-header>
*/

import { AnnouncementBar } from '../AnnouncementBar/AnnouncementBar';
import { CartMain } from "../Cart/CartMain";
import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { debounce } from 'lodash';
import { SideCart } from '../SideCart/SideCart';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class SiteHeader extends ThemeComponent {
    @Ref() row!: HTMLDivElement;
    @Ref() wrapper!: HTMLDivElement;
    @Ref({required: false}) cartTrigger!: HTMLDivElement[];
    @Ref() menuToggle!: HTMLElement[];
    @Ref({required: false}) count!: HTMLElement[];
    @Ref({ required: false }) announcement!: AnnouncementBar;
    @Ref({ required: false}) childListTrigger!: HTMLElement[];
    @Ref({ required: false}) childList!: HTMLElement[];

    private _onOpenChange = new SimpleEvent<string>();
    private sideCart:SideCart|null = document.body.querySelector('side-cart');

    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }

    public changeOpen(open: string) {
        // Use the private backing field to dispatch
        this._onOpenChange.dispatch('');
    }

    init() {

        // this.handleBodyPadding();
        this.setEventListeners();

        const cartMain = document.body.querySelector('cart-main') as CartMain;
        this.$subscribe(cartMain.onCartItemCountChange, debounce((value) => {
            this.updateCartCount(value);
        }, 300));




    }

    /**
     * Set event listeners.
     */
    setEventListeners() {
        this.$listen(window, 'resize',
            debounce(() => {
                this.handleBodyPadding();
            }, 300)
        );

        this.handleBodyPadding();
        this.cartEvent();
        this.menuEvent();

        let item: HTMLElement;
        for( item of this.childListTrigger) {
            item.addEventListener('mouseover', () => {

                let list: HTMLElement;
                for(list of this.childList) {
                    list.classList.add('active');
                    list.addEventListener('mouseleave', () => {
                        list.classList.remove('active');
                        const parentLinks = document.querySelectorAll('.site-header__nav--parent-link');
                        for (const parent of parentLinks ) {
                            parent.addEventListener('mouseover', () => {
                                list.classList.remove('active');
                            });
                        }

                    });
                }
            });
        }





    }
    /**
     * Handle Body Padding.
     */
    // private handleBodyPadding() {
    //     const height = this.offsetHeight;
    //     document.body.style.paddingTop = `${height}px`;
    // }

    private handleBodyPadding() {
        // Wait for DOMContentLoaded event
        const headerHeight = this.wrapper.offsetHeight;
        document.body.style.paddingTop = `${headerHeight}px`;
    }
    /**
     * Cart Close click event.
     * @returns
     */
    cartEvent() {
        if (!this.cartTrigger) { return; }
        for (const trigger of this.cartTrigger) {
            this.$listen(trigger, 'click', (event) => {
                event.preventDefault();

                if (!this.sideCart) { return; }
                this.sideCart.openCart();
            });
        }

    }

    menuEvent() {
        for (const toggle of this.menuToggle) {
            this.$listen(toggle, 'click', (event) => {
                event.preventDefault();
                document.dispatchEvent(new Event('openMenu'));
            });
        }
    }

    /**
     * Update cart count
     * @returns
     */
    private updateCartCount(count: number) {
        if (!this.count) { return; }
        for (const countElement of this.count) {
            countElement.innerHTML = String(count);

            // if (count > 0) {
            //     countElement.parentElement?.classList.add('is-active');
            // } else {
            //     countElement.parentElement?.classList.remove('is-active');
            // }
        }

    }
}
